import "./index.scss"
import scene1 from "../../assets/scene1.png"
import scene2 from "../../assets/scene2.png"
import scene3 from "../../assets/scene3.png"
import scene4 from "../../assets/scene4.png"
import Feedback from "../../components/Feedback"
import { useState } from "react"
function Scene() {
  const [isHide, setIshide] = useState(true);
  const [position, setPosition] = useState({ top: "50%", left: "50%" });
  function showFDialog(pp) {
    setPosition(pp);
    setIshide(false);
  }
  // 隐藏 二维码框
  function mouseLeave() {
    setIshide(true);
  }
  // 免费试用 弹框
  function freeTrialEnter() {
    let freeTrialDom = document.querySelector("#freeTrialDom");
    showFDialog({
      top: "250px",
      left: freeTrialDom.offsetLeft - 155 + freeTrialDom.offsetWidth / 2 + "px",
    });
  }
  const list = [
    {
      id: 1,
      avatar: scene1,
      avatarTitle: "国央企-资产风控管理",
      itemList: [
        { title: "司库体系建设", content: ["再查查助力国央企响应国资委号召加速司库体系建设。通过集成多维度数据，强化司库系统的智能分析、风险预警与合规管理能力,确保资金安全高效运作。"] },
        { title: "投资决策支持", content: ["国有企业在进行对外投资时，利用再查查平台深入分析目标企业的财务状况、经营能力及市场潜力，为投资决策提供可靠数据支持，降低投资风险。"] },
        { title: "逾期应收账款管理", content: ["通过对债务企业的多维数据分析，帮助国央企全面了解债务企业经营情况及财产线索，制定有效的清收策略，提高账款回收率，降低资金损失。"] },
        { title: "供应链管理优化", content: ["再查查平台帮助国有企业快速识别潜在风险供应商，通过分析供应商的采购、销售及纳税情况，优化供应链管理，提高供应链的稳定性和效率。"] },
      ]
    }, {
      id: 2,
      avatar: scene2,
      avatarTitle: "金融机构应用场景",
      itemList: [
        {
          title: "信贷审批", content: ["系统融合全国司法数据及企业多维数据，通过深度挖掘分析构建企业信息立体画像，帮助金融机构全面评估借款企业信用风险及经营情况，从而更精准地做出信贷审批决策，降低违约风险。"]
        },
        {
          title: "风险管理", content: ["用户不仅可以主动查询目标企业的多维度风险信息，还可以对高风险企业添加监控，当相关企业动态发生变化时，系统将通过管理后台日报弹窗、手机短信、微信公众号等渠道推送实时提醒，辅助人工判断。监控消息界面支持多维度筛选，方便用户快速定位关键信息，构建全面、智能的风险防控体系。"]
        },
        { title: "特殊资产", content: ["系统依托企业多维数据分析、财产线索挖掘、抵押房产土地智能估值及尽调报告自动生成等核心功能，实时监控并预警债务企业风险。支持批量分配跟进人，助力金融机构优化资源配置，提升特殊资产管理及处置效能。"] },
      ]
    },
    // {
    //   id: 3,
    //   avatar: scene3,
    //   title: "逾期应收账款管理",
    //   avatarTitle: "金融机构特殊资产",
    //   content: ["通过对债务企业的多维数据分析，帮助国央企全面了解债务企业经营情况及财产线索，制定有效的清收策略，提高账款回收率，降低资金损失。"]
    // }, {
    //   id: 4,
    //   avatar: scene4,
    //   title: "供应链管理优化",
    //   avatarTitle: "金融机构信贷审批",
    //   content: ["再查查平台帮助国有企业快速识别潜在风险供应商，通过分析供应商的采购、销售及纳税情况，优化供应链管理，提高供应链的稳定性和效率。"]
    // }
  ]
  const [currentId, setCurrentId] = useState(1)
  function handleMouseEnter(id) {
    setCurrentId(id)
  }
  return (
    <div className="scene-container">
      <div className="subtitle">应用场景</div>
      <div className="title">APPLICATION SCENARIOS</div>
      <div className="avatar-row">
        {list.map(item => {
          return (
            <div className="avatar-item" style={{ cursor: "pointer", backgroundColor: item.id === currentId ? 'rgba(255, 255, 255, 0.10)' : 'transparent' }} key={item.id} onMouseEnter={() => handleMouseEnter(item.id)} onClick={() => handleMouseEnter(item.id)}>
              <img className="avatar" src={item.avatar}></img>
              <div className="avatarTitle">{item.avatarTitle}</div>
            </div>
          )
        })}
      </div>
      <div className="scene-info">
        {list.map((item) => {
          if (item.id === currentId) {
            return (item.itemList.map((subItem, subIndex) => {
              if (item.itemList.length === 4) {
                return (<div key={subIndex} className="list-item">
                  <div className="title-row">
                    <span className="title">{subItem.title}</span>
                  </div>
                  <div className="content">
                    {subItem.content.map((content, contentIndex) => {
                      return (<div className="content-item" key={contentIndex}>{content}</div>)
                    })}
                  </div>
                </div>)
              } else {
                return (
                  <div key={subIndex} className="three-list-item">
                    <div className="three-title-row">
                      <span className="three-title">{subItem.title}</span>
                    </div>
                    <div className="three-content">
                      {subItem.content.map((content, contentIndex) => {
                        return (<div className="three-content-item" key={contentIndex}>{content}</div>)
                      })}
                    </div>
                  </div>
                )
              }

            })

            )
          }
        })}
        <div className="learn-more" id="freeTrialDom" onMouseEnter={freeTrialEnter}
          onMouseLeave={mouseLeave}></div>
        <Feedback
          isHide={isHide}
          position={position}
          tip="扫码填写资料，等待客服联系"
        />
      </div>

    </div>
  )
}
export default Scene